import { render } from "./ResetPasswordNotify.vue?vue&type=template&id=210445a9&scoped=true"
import script from "./ResetPasswordNotify.vue?vue&type=script&lang=js"
export * from "./ResetPasswordNotify.vue?vue&type=script&lang=js"

import "./ResetPasswordNotify.vue?vue&type=style&index=0&id=210445a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210445a9"]])

export default __exports__